import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--receipts--extras"
export default class extends Controller {
  static targets = [
    "minusButton",
    "plusButton",
    "factor",
    "amount"
  ]

  static values = {
    amount: Number,
  }

  decrement() {
    if (this.factorTarget.innerHTML == 0) { return }

    this.factorTarget.innerHTML = parseInt(this.factorTarget.innerHTML) - 1
    this.amountTarget.value = this.factorTarget.innerHTML * this.amountValue

    this.amountTarget.dispatchEvent(new Event('input', { 'bubbles': true }))
  }

  increment() {
    if (this.factorTarget.innerHTML == 10) { return }

    this.amountTarget.value = this.factorTarget.innerHTML = parseInt(this.factorTarget.innerHTML) + 1
    this.amountTarget.value = this.factorTarget.innerHTML * this.amountValue

    this.amountTarget.dispatchEvent(new Event('input', { 'bubbles': true }))
  }
}
